import { Exploration } from '@/explore/types';

import { isRelationAggregateOperation } from '@/explore/pipeline/operation';

import { getVariableDefinitions } from '@/explore/utils';

import { setExplorationCells } from '.';
import { isCellWithPipeline, setCellPipeline } from '../cell';
import {
  ensureValidUseOfVariablesInFilter,
  ensureValidUseOfVariablesInRelationAggregate,
  isFilterOperation,
} from '../operation';

export const ensureValidUseOfVariables = (exploration: Exploration): Exploration => {
  const definitions = getVariableDefinitions(exploration);
  return setExplorationCells(
    exploration,
    exploration.view.cells.map((cell) =>
      isCellWithPipeline(cell)
        ? setCellPipeline(cell, {
            ...cell.pipeline,
            operations: cell.pipeline.operations.map((operation) => {
              switch (true) {
                case isFilterOperation(operation):
                  return ensureValidUseOfVariablesInFilter(operation, definitions);
                case isRelationAggregateOperation(operation):
                  return ensureValidUseOfVariablesInRelationAggregate(operation, definitions);
                default:
                  return operation;
              }
            }),
          })
        : cell,
    ),
  );
};
